import PhotoSwipe from 'photoswipe/dist/photoswipe';
import * as PhotoSwipeUI from 'photoswipe/dist/photoswipe-ui-default';
import getLargestImageSize from './getLargestImageSize';

/**
 * Component for Lightbox.
 */
export default class Lightbox {
  /**
   * Start the component.
   */
  constructor({ element, children, options }) {
    this.element = element;
    this.children = children;
    this.options = options;

    // Save children as instance properties.
    Object.assign(this, this.children);

    // Bind class methods.
    this.openLightbox = this.openLightbox.bind(this);
    this.init = this.init.bind(this);

    this.init();
  }

  init() {
    this.image.addEventListener('click', this.openLightbox);
  }

  /**
   * Initialzes the lightbox modal.
   */
  openLightbox() {
    const largestSize = getLargestImageSize(this.image);
    const item = {
      src: largestSize.src,
      w: largestSize.width,
      h: largestSize.height,
    };

    // Add caption if one is present.
    if (null !== this.figcaption) {
      item.title = this.figcaption.outerHTML;
    }

    const options = {
      index: 0,
      closeOnScroll: false,
      history: false,
      shareEl: false,
      counterEl: false,
      arrowEl: false,
      clickToCloseNonZoomable: false,
      tapToToggleControls: false,
    };

    // Initializes and opens PhotoSwipe
    const gallery = new PhotoSwipe(
      document.querySelector('.pswp'),
      PhotoSwipeUI,
      [item],
      options,
    );
    gallery.init();

    // Target for styles to apply while lightbox is open.
    document.body.classList.add('lightbox-open');
    gallery.listen('close', () => {
      document.body.classList.remove('lightbox-open');
    });
  }
}
